import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import PriceIcon from './MobileNav/MainMenu/MagazinesMenu/SpecialDealsPanel/PriceIcon';

type Props = {
  href: string;
  title: string;
  icon?: IconLookup;
  priceIcon?: {
    price: string;
  };
};

export default function SpecialDealLink({ href, title, icon, priceIcon }: Props) {
  return (
    <a href={href} className="inline-flex flex-col items-center justify-center group">
      <div className="w-full h-16 bg-red-100 group-hover:bg-red-200 group-active:bg-red-300/60 rounded-md inline-flex items-center justify-center text-lg">
        {icon && !priceIcon && (
          <FontAwesomeIcon
            icon={icon}
            size="2x"
            className="text-red-600 group-hover:text-red-700 group-active:text-red-800"
          />
        )}
        {priceIcon && <PriceIcon price={priceIcon.price} />}
      </div>
      <div className="text-sm leading-tight font-semibold text-center mt-2">{title}</div>
    </a>
  );
}
